import React from "react";
import PropTypes from "prop-types";
import { Body1, H6 } from "common/DS/Text";
import classNames from "classnames";

// Note/Info about dimensions: component is responsive (yay!) but Figma doesn't support max-width
// (boo!) so be careful when this is in a design to check your width & positioning.

// Helper text should be used unless multiple components are necessary,
// in which case please use Body1 or Body1 inside a p tag

const ZeroState = ({
    icon,
    title,
    helperText,
    helperTextComponent, // Body1 or Body1 inside p
    buttons,
    isMinimal,
    padding,
    additionalClassName,
    dataTest,
}) => {
    const titleComponent = <H6>{title}</H6>;
    const helper = helperTextComponent || <Body1>{helperText}</Body1>;
    return (
        <>
            {isMinimal && (
                <div
                    className={classNames(
                        "zero-state__minimal",
                        additionalClassName,
                        `py-${padding}`,
                    )}
                    data-test={dataTest}
                >
                    {titleComponent}
                </div>
            )}
            {!isMinimal && (
                <div
                    className={classNames("zero-state", additionalClassName, `py-${padding}`)}
                    data-test={dataTest}
                >
                    <div className="zero-state zero-state__content">
                        {icon}
                        {titleComponent}
                        {helper}
                        {!!buttons && <div className="zero-state__buttons">{buttons}</div>}
                    </div>
                </div>
            )}
        </>
    );
};
ZeroState.defaultProps = {
    icon: null,
    helperText: null,
    helperTextComponent: null,
    buttons: null,
    isMinimal: false,
    padding: "lg",
    additionalClassName: null,
    dataTest: null,
};

ZeroState.propTypes = {
    icon: PropTypes.node,
    title: PropTypes.string.isRequired,
    helperText: PropTypes.string,
    helperTextComponent: PropTypes.node,
    buttons: PropTypes.node,
    isMinimal: PropTypes.bool,
    padding: PropTypes.oneOf(["lg", "xxl"]),
    additionalClassName: PropTypes.string,
    dataTest: PropTypes.string,
};

export default ZeroState;
